import React from "react";
import { Card } from "../ui-bj/Primitives";
import { MagnifyingGlass } from "@phosphor-icons/react";
import { relabel } from "../../lib/displayNames";

export const ClientFilters = ({
  query, setQuery,
  status, setStatus, statusOpts,
  pkg, setPkg, pkgOpts,
  service, setService, svcOpts,
  showing,
}) => {
  const selects = [
    { label: "Status",  value: status,  set: setStatus, opts: statusOpts, testid: "filter-status" },
    { label: "Package", value: pkg,     set: setPkg,    opts: pkgOpts,    testid: "filter-package" },
    { label: "Service", value: service, set: setService, opts: svcOpts,   testid: "filter-service" },
  ];

  return (
    <Card className="mb-5">
      <div className="grid grid-cols-1 md:grid-cols-12 gap-3 items-end">
        <div className="md:col-span-5">
          <label className="bj-label block mb-1">Search</label>
          <div className="relative">
            <MagnifyingGlass size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-[#5E4D40]" />
            <input
              data-testid="clients-search-input"
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              placeholder="Name, Client ID, consultant, email…"
              className="w-full bg-[#DCCFB9] border border-[rgba(42,28,21,0.18)] text-[#2A1C15] text-sm pl-9 pr-3 py-2 focus:outline-none focus:border-[#C8A46A]"
            />
          </div>
        </div>
        {selects.map((f) => (
          <div key={f.label} className="md:col-span-2">
            <label className="bj-label block mb-1">{f.label}</label>
            <select
              data-testid={f.testid}
              value={f.value}
              onChange={(e) => f.set(e.target.value)}
              className="w-full bg-[#DCCFB9] border border-[rgba(42,28,21,0.18)] text-[#2A1C15] text-sm px-2 py-2 focus:outline-none focus:border-[#C8A46A]"
            >
              {f.opts.map((o) => <option key={o} value={o}>{relabel(o)}</option>)}
            </select>
          </div>
        ))}
        <div className="md:col-span-1 text-right">
          <div className="bj-label">Showing</div>
          <div className="font-heading text-[#6E5022] text-2xl bj-tnum">{showing}</div>
        </div>
      </div>
    </Card>
  );
};
